export const getCreatedResumeAPI="/platform-created-resume";
export const postCreatedResumeAPI="/platform-created-resume";